<div class="apollo-main upload">
    <header>
        <div class="data-header">
            <h2>File comparison</h2>
            <plugin-apollo-helpers-compare-buttons
                *ngIf="buttons.enabled"
                class="compare-component"
                [graphic]="buttons.graphic"
                [content]="buttons.content"
            >
            </plugin-apollo-helpers-compare-buttons>
            <p>You can quality control your files using our comparison engine (graphic and content wise).</p>
        </div>
    </header>

    <div class="instructions">
        <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
        <ol *ngIf="show">
            <li>Upload your <strong>REFERENCE</strong> document (click or drag).</li>
            <li>Upload your <strong>TARGET</strong> document (click or drag).</li>
            <li> <strong>Review, crop, rotate</strong> and select pages for each document.</li>
        </ol>
    </div>

    <core-helpers-box-loading [hidden]="!hashLoad.loading"></core-helpers-box-loading>
    
    <div *ngIf="!hashLoad.loading" class="two-boxes-plugin">

        <div class="box-plugin box-single">
            <h3>Your Reference</h3>
            <plugin-apollo-helpers-item-upload [paramfileId]="referenceFileId" [propertyName]="'reference'"></plugin-apollo-helpers-item-upload>
        </div>

        <div class="box-plugin box-single">
            <h3>Your Target</h3>
            <plugin-apollo-helpers-item-upload [paramfileId]="targetFileId" [propertyName]="'target'"></plugin-apollo-helpers-item-upload>
        </div>

    </div>


    <footer>
        <plugin-apollo-helpers-compare-buttons
            *ngIf="buttons.enabled"
            class="compare-component"
            [graphic]="buttons.graphic"
            [content]="buttons.content"
        >
        </plugin-apollo-helpers-compare-buttons>
    </footer>


</div>
